import React from "react";
import AddInventory from "../components/inventory/AddInventory";
import InventoryList from "../components/inventory/InventoryList";
import AddInventoryHeader from "../components/inventory/AddInventoryHeader";

export default function AddInventoryPage() {
  return (
    <>
      <AddInventoryHeader />
      <InventoryList />
    </>
  );
}
